@if (!isInsideIframe) {
  <zbp-resources-header />
}

<section id="viewerContainer" class="viewer-container">
  <zbp-loading-placeholder *ngIf="shouldDisplayLoader$ | async"></zbp-loading-placeholder>

  <ng-container *ngIf="viewerAsset$ | async as asset">
    <ng-container *ngIf="asset.assetId">
    <header id="viewerHeader" class="viewerHeader w-100 d-flex flex-nowrap justify-content-between align-items-baseline p-2 m-0">
      <button id="backToPortal" tabindex="0" class="d-block nav-link py-0" (click)="close()" data-cy="viewer-header-back">
            <div><i class="fa fa-times" aria-hidden="true"></i> CLOSE ASSET</div>
        </button>
      <h1 class="h6 my-0 viewer-header-title" data-cy="viewer-header-title" [innerHTML]="asset.category + ' - ' + asset.name"></h1>
      <div class="viewerHeaderToggleContainer" ngbDropdown [autoClose]="'inside'" #toggleDropdown="ngbDropdown">
        <button *ngIf="hasTopicKey$ | async" id="toggleDropdownButton" class="btn btn-sm" ngbDropdownToggle [innerHTML]="asset.name"></button>
        <div *ngIf="toggleAssets$ | async as toggleAssets" aria-labelledby="toggleDropdownButton" ngbDropdownMenu>
          <ng-container *ngFor="let toggleAsset of toggleAssets; index as i">
            <button id="toggleAssetButton{{i}}" type="button" class="btn btn-sm assetToggleButton" ngbDropdownItem
              (click)="handleToggledAsset(toggleAsset.assetId)" [innerHTML]="renderText(toggleAsset.name)"></button>
          </ng-container>
        </div>
      </div>
    </header>

    <main id="viewer" [ngClass]="isZBPortal ? 'viewer-component material-viewer-zbportal-background' : 'material-viewer-highlights-background'">
      <aside *ngIf="messages$ | async as messages" id="viewerAlert" role="alert" class="alert w-75 mx-auto my-1 text-center"
        [class.alert-danger]="messages?.length">
          <ul id="viewerAlertList" *ngFor="let message of messages">
            <li>{{ message }}</li>
          </ul>
        </aside>
      <div class="viewer-wrapper">
        @if (viewerConfig$ | async) {
          <div class="viewer-controls">
            <zbp-viewer-controls
              [viewerConfiguration]="viewerConfiguration"
              [asset]="asset"
              [viewerAssets]="assetList"
              (activeTool)="setActiveTool($event)"
              (zoomPercent)="setZoomPercent($event)"
              (triggerPrint)="printImage()">
            </zbp-viewer-controls>
          </div>
        }
          <div *ngIf="{series: series$ | async, grade: grade$ | async} as apipe"
               class="viewerAssetWrapper">
            <ng-container [ngSwitch]="asset.viewerAssetType">
              <zbp-viewer-audio *ngSwitchCase="'Audio'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade" [viewerAssets]="assetList"
                (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-audio>
              <zbp-viewer-canvas *ngSwitchCase="'Canvas'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"
                                 [zoomLevel]="zoomPercent"
                                 [selectedTool]="activeTool"></zbp-viewer-canvas>
              <zbp-viewer-canvas
                *ngSwitchCase="'Image'"
                [asset]="asset"
                [series]="apipe.series"
                [grade]="apipe.grade"
                (loaded)="shouldDisplayLoader$.next(false); onImageLoaded()"
                (withError)="handleError($event)"
                [zoomLevel]="zoomPercent"
                [selectedTool]="activeTool"
              />
              <zbp-viewer-document *ngSwitchCase="'Pdf'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"
                                   [zoomLevel]="zoomPercent"
                                   [locked]="false"
                                   [selectedTool]="activeTool"></zbp-viewer-document>
              <zbp-viewer-document *ngSwitchCase="'PdfLocked'" [asset]="asset" [series]="apipe.series"
                                          [grade]="apipe.grade" (loaded)="shouldDisplayLoader$.next(false)"
                                          (withError)="handleError($event)"
                                          [zoomLevel]="zoomPercent"
                                          [locked]="true"
                                          [selectedTool]="activeTool"></zbp-viewer-document>
              <zbp-viewer-iframe *ngSwitchCase="'Ilb'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-iframe>
              <zbp-viewer-iframe *ngSwitchCase="'Iwb'" [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-iframe>
              <zbp-viewer-iframe
                *ngSwitchCase="'SuperSmart'"
                [asset]="asset"
                [series]="apipe.series"
                [grade]="apipe.grade"
                (loaded)="shouldDisplayLoader$.next(false); onSuperSmartLoaded();"
                (withError)="handleError($event)"
              />
              <zbp-viewer-print-canvas *ngSwitchCase="'ImagePrint'" [asset]="asset" [series]="apipe.series"
                                       [grade]="apipe.grade"
                                       (loaded)="shouldDisplayLoader$.next(false)"
                                       (withError)="handleError($event)"
                                       [zoomLevel]="zoomPercent"
                                       [selectedTool]="activeTool"
                                       [triggerPrint]="triggerPrint"
                                       (isPrinting)="triggerPrint = $event.valueOf()"
              ></zbp-viewer-print-canvas>
              <zbp-viewer-video
                *ngSwitchCase="'Video'"
                [asset]="asset"
                (loaded)="shouldDisplayLoader$.next(false)"
                (withError)="handleError($event)"
                [zoomLevel]="zoomPercent"
                [selectedTool]="activeTool"
                (completed)="onVideoCompleted()"
              />
              <zbp-viewer-video-canvas *ngSwitchCase="'VideoCanvas'" [asset]="asset" [series]="apipe.series"
                                       [grade]="apipe.grade"
                                       [selectedTool]="activeTool"
                                       (loaded)="shouldDisplayLoader$.next(false)"
                                       (withError)="handleError($event)"></zbp-viewer-video-canvas>

            </ng-container>
          </div>
      </div>
      @if (!isInsideIframe) {
        <zbp-footer class="material-footer"></zbp-footer>
      }
    </main>
  </ng-container>
</ng-container>


</section>
